import { Platform, StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { ThemedView } from '@app/theme'
import _ from 'lodash'
import WebView, { WebViewMessageEvent } from 'react-native-webview'
import { signDeskSDKUrl } from '@app/api/apis'
import { validateEsignApi } from '../tataEsignService'
import { useAppSelector } from '@app/store/hooks'

const TataEsignWebview = ({ eSignResponse , onSuccess }: { eSignResponse: any , onSuccess: (success : string) => void }) => {

  const applicationId = useAppSelector((state) => state?.auth?.userDetails?.linkedApplications[0]?.applicationId);


  let docketId = _.get(eSignResponse, 'data.stepResponseObject.docketId')
  let documentId = _.get(eSignResponse, 'data.stepResponseObject.documentId')
  let signId = _.get(eSignResponse, 'data.stepResponseObject.signerIds[0]')
  let id = _.get(eSignResponse, 'data.stepResponseObject.applicationId')


  const handleWebViewLoad = async (value: string) => {
    await validateEsignApi({ applicationId: applicationId, widgetToken: value });
  }



  const onMessage = (event: WebViewMessageEvent) => {
    if (event.nativeEvent?.data === "failed" || event.nativeEvent?.data === "success") {
        onSuccess(event.nativeEvent.data);
    }
    else {
      try {
        handleWebViewLoad(event.nativeEvent.data)
      } catch (error) {

        console.error('Error processing WebView message:', error);
      }
    }
  };

  return (
    <ThemedView style={{ flex: 1 }}>

      <WebView
        containerStyle={{ height: Platform.OS === "ios" ? 260 : 300, width: '100%', marginTop: 30 }}
        style={{ height: Platform.OS === "ios" ? 260 : 300, width: '100%' }}
        scalesPageToFit={true}
        originWhitelist={['*']}
        useWebKit={true}
        source={{
          html: ` 
          <html>
<body>
<script type="text/javascript" src="${signDeskSDKUrl}"></script>
<script type="text/javascript">
         var options = {
            id: "${id}",
            docket_id: "${docketId}",
        signer_id: "${signId}",
        document_id: "${documentId}",
                    widget_width:"100%", //optional
            widget_height:"100%", //optional

            getWidgetToken: function (resulta) {
                setTimeout(()=> {
                 sendDataToReactNativeApp(resulta);
   
                },(1000))
            }, 
            signatureStatus: function (result) {
                 sendDataToReactNativeApp(result.status);

            },
            errorLog: function (result) {
                console.log("RESULT RECEIVED FROM ERROR", result.status,result.error)
               console.log(result);
            },
         };
        esignWidgetCall(options);
        
           const sendDataToReactNativeApp = async (data) => {
                window.ReactNativeWebView.postMessage(data);
              };
      </script>
</body>
</html>
`,
        }}
        onMessage={onMessage}
        javaScriptEnabled={true}
        javaScriptEnabledAndroid={true}
        javaScriptCanOpenWindowsAutomatically
        allowFileAccess
        domStorageEnabled={true}
        mixedContentMode={'always'}
        mediaPlaybackRequiresUserAction={false}
        allowsInlineMediaPlayback={true}
      />
    </ThemedView>
  )
}

export default TataEsignWebview

const styles = StyleSheet.create({})